import { AxiosResponse } from 'axios';
import { environment } from 'environments/environment';
import axiosApiInstance from '../CustomAxiosInstance';
import drProxPractitionerInstance from '../../clients/api/dr-prox-practitioner-instance';
import { IBasicOrganizationData, IPractitioner, IPractitionerProfile, IUserOrganization, OrganizationCalendarI, PractitionerStatus } from '../../interfaces/api/practitioner';
import initialQuizInstance from '../../clients/api/initial-quiz-instance';
import drProxServicesInstance from '../../clients/api/dr-prox-services-instance';
import signupInstance from '../../clients/api/signup-instance';
import { ISystemInfo } from '@interfaces/api/system';

export function getPractitionersList(page: number, size: number, searchTitle: string, timezone: string): Promise<AxiosResponse> {
    return axiosApiInstance.get(`${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/drprox/practitioners/validate?page=${page}&searchTitle=${searchTitle}&size=${size}&timezone=${timezone}`);
}

export function getPractitioners(page: number, size: number, searchTitle: string, timezone: string): Promise<AxiosResponse> {
    return axiosApiInstance.get(`${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/drprox/practitioners?page=${page}&searchTitle=${searchTitle}&size=${size}&timezone=${timezone}`);
}

export async function getPractitionersByStatus(status: PractitionerStatus)
{
    const endpoint = `/practitioner/practitioners/validate?searchTitle=${status}`;
    const response = await drProxPractitionerInstance.get<IPractitioner[]>(endpoint);
    return response.data;
}

export async function validatePractitioner(practitionerId: string)
{
    const endpoint = `/practitioner/initial-quiz/validate/${practitionerId}`;
    const response = await initialQuizInstance.put(endpoint);
    return response.status;
}

export async function createPractitionerOrganization(practitionerUsername: string)
{
    const endpoint = `/organization/default/user/${practitionerUsername}`;
    const response = await drProxServicesInstance.put(endpoint);
    return response.status;
}

/**
 * @deprecated
 */
export async function getUserOrganizations(practitionerUsername: string)
{
    const endpoint = `/person/practitioner/profile/organization/${practitionerUsername}`;
    const response = await signupInstance.get<IUserOrganization[]>(endpoint);
    return response.data;
}
export async function getPractitionerOrganizationM2(userName: string) {
    const endpoint = `practitioner/contract/profile/organization/${userName}/v2`; 
    const response = await drProxServicesInstance.get<OrganizationCalendarI[]>(endpoint);
    return response.data;
}
export async function getPractitionerOrganizations(practitionerUsername: string) {
    const endpoint = `practitioner/contract/profile/organization/${practitionerUsername}`;
    const response = await drProxServicesInstance.get<IBasicOrganizationData[]>(endpoint);
    return response.data;
}
export async function validatePractitionerProfession(professionId: string)
{
    const endpoint = `/practitioner/profile/profession/validate/${professionId}`;
    const response = await drProxPractitionerInstance.put(endpoint);
    return response.status;
}

export async function validatePractitionerSpecialties(professionId: string, specialityId: string)
{
    const endpoint = `/practitioner/profile/profession/speciality/validate/${professionId}/${specialityId}`;
    const response = await drProxPractitionerInstance.put(endpoint);
    return response.status;
}

export async function getPractitionerProfile(practitionerUsername: string)
{
    const endpoint = `/practitioner/profile/${practitionerUsername}`;
    const response = await drProxPractitionerInstance.get<IPractitionerProfile>(endpoint);
    return response.data;
}

export async function getPractitionerStatus(practitionerUsername: string)
{
    const endpoint = `/practitioner/status/${practitionerUsername}`;
    const response = await drProxPractitionerInstance.get<boolean>(endpoint);
    return response.data;
}

export async function getPlatformVersion()
{
    const endpoint = "/system/info/operational";
    const response = await signupInstance.get<ISystemInfo>(endpoint);
    return response.data;
}
